import { FC } from 'react';

import { BookmarkIconButton } from '@bonusly/common-bookmark';
import { RelativeTime } from '@bonusly/common-relative-time';
import { Box, HStack, Image, rem, Spacer } from '@bonusly/design-system';
import { useCurrentCompany, useFeatureFlag, Variant } from '@bonusly/who-am-i';

import { getCelebrationStyles } from '../../../../../components/celebrations/utils';
import { CelebrationType } from '../../../../../schemas/celebrations';
import { Reveal } from '../../../../display/reveal';
import { BonusOptionsMenu, BonusOptionsMenuProps } from '../../components/bonus/bonus-options-menu';
import { Chip } from '../../components/common/chip';

export type CelebrationHeaderProps = BonusOptionsMenuProps;

export const CelebrationHeader: FC<CelebrationHeaderProps> = ({ bonus, ...rest }) => {
	let { icon_url } = bonus;
	const company = useCurrentCompany();
	const isSpotlightTriggerEnabled = useFeatureFlag(Variant.EmployeeSpotlightTrigger);
	const { iconComponent, bgColor } = getCelebrationStyles(bonus.award_type as unknown as CelebrationType, isSpotlightTriggerEnabled);

	const showAmount = company.show_bonus_amounts && !!bonus.family_amount;

	return (
		<HStack alignItems="center" spacing={2} data-testid="award-header">
			{icon_url && <Image src={icon_url} boxSize={rem(40)} borderRadius="full" />}

			{!icon_url && iconComponent && (
				<Box bgColor={bgColor} boxSize={rem(40)} borderRadius="full" overflow="hidden" borderColor="border.default" borderWidth="1px" borderStyle="solid">
					{iconComponent}
				</Box>
			)}

			<Reveal if={showAmount}>
				<Chip size="sm" variant="amount" height="auto">
					+{bonus.family_amount}
				</Chip>
			</Reveal>

			<Spacer />

			<RelativeTime color="text.soft" date={new Date(bonus.created_at)} />

			<BookmarkIconButton />

			<BonusOptionsMenu bonus={bonus} boxSize={10} {...rest} />
		</HStack>
	);
};
